import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

// Top scroll-progress bar + global film grain trigger lives in App via .grain class.
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      className="fixed left-0 top-0 z-[10000] h-[2px] w-full origin-left bg-gold"
      style={{ scaleX }}
      data-testid="scroll-progress"
    />
  );
}
